import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDomainsByExpert, fetchUsers_demoted } from "../../../../API/api";
import { Table } from "antd";
import { Spin } from "antd";
import DomainSpecificGraphComponent from "../../../GraphComponent/DomainSpecificGraphComponent";
import { Grid, Paper } from "@mui/material";
import VizHeader from "../../../VizHeader/VizHeader";
import TitleValue from "../seeker/TitleValue";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { filterDomainsForComponent2 } from "../../../../utils";
import { bindActionCreators } from "redux";
import { Actions } from "../../../../Action";
import styles from './ExpertOverview.module.css'

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const textStylesHeader = {
  fontSize: "18px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};

const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};

const containerStyles1 = {
  width: "80%",
  margin: "auto",
  // marginTop:"1%",
  // marginTop: "6%",
  // marginBottom: "7%",
  // border: '1px solid #EAECF0',
  // boxShadow: '0px 4px 16px 0px #1018280F',
  // borderRadius: '12px',
  // minHeight:'450px',
  padding: '0px 24px 0px 0px',
  // paddingBottom:'0px'
  // Height:"100%"




}; 
function ExpertAnswers() {
  const [expertData, setExpertData] = React.useState(null);
  const cmOverviewReducer = useSelector((state) => state.cmOverview)
  const currentPath = useLocation()
  const expertRecordsState = useSelector((state) => state.expertRecord)
  const [domain, setDomain] = React.useState();
  const dispatch = useDispatch();
  const { cmRootUpdateDomainVal, crossnavigationExpertCuration, getDomainNameFromExpertOverview } =
    bindActionCreators(Actions, dispatch);
  const { geoLevelId, geoLevelValue, length, check, domainId } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );
  const userState = useSelector((state) => state.user);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    // if (localStorage.getItem('domainName') !== undefined) {
    //   let newArray = filterDomainsForComponent2(userState.cmTopics)
    //   cmRootUpdateDomainVal(newArray)
    // }
    if (check !== "") {
      setLoading(true);
      getDomainsByExpert(
        geoLevelId,
        geoLevelValue === undefined ? "" : geoLevelValue,
        false,
        domainId
      ).then((res) => {
        if (res === undefined) return;
        setLoading(false);
        setExpertData(res?.data?.data);
      });
    }
    return () => {
      if (localStorage.getItem('domainName') !== undefined) {
        let newArray = filterDomainsForComponent2(userState.cmTopics)
        let result = newArray.filter((obj) => {
          if (obj.value === localStorage.getItem('domainName')) {
            return obj;
          }
        })
      }
      setDomain(undefined)
    }
  }, [geoLevelId, geoLevelValue, length, check, domainId]);


  const domainNames = [...new Set(expertData?.map((item) => item.domainName))];
  const navigate = useNavigate();

   const crossNavigation = (data, domain)=>{
    let arr = data.expertName.split('###');
    let obj1 = {
      geoLevelId: geoLevelId, geoLevelValue: geoLevelValue, length: length, check: check, domainId:
        domainId,domainName:domain
    }
  
    localStorage.setItem('domainName',domain)
    fetchUsers_demoted(arr[0]).then(res=>{
      if (res===undefined) return;
      let desiredData = res.data.data.users.filter(obj=>{
        if(obj.userUuid === arr[1]){
          return obj; 
        }
      });
      let allDomain = filterDomainsForComponent2(userState.cmTopics).filter(
        (obj2) => {
          if (obj2.value === domain) {
            return obj2;
          }
        }
      );
      // console.log("allDomain",allDomain);
      // console.log("obj1",obj1)
    
      crossnavigationExpertCuration({ email: desiredData, curation: [] });
      
      // cmRootUpdateDomainVal(allDomain);
      //   getDomainNameFromExpertOverview(obj1)
      navigate("/cmHome/expertResponses/");

    
    });

    return;
  };
  const reversedData = domainNames.reverse();
  const tableData = {};
  expertData?.forEach((item) => {
    if (!tableData[item.expertName]) {
      tableData[item.expertName] = {};
    }
    tableData[item.expertName][item.domainName] = {
      answerCount: item.answerCount,
      rating: item.rating,
      ratingCount: item.ratingCount,
    };
  });
  // Columns configuration
  reversedData.sort((a, b) => {
    // Convert strings to lowercase for case-insensitive comparison
    const lowerA = a.toLowerCase();
    const lowerB = b.toLowerCase();

    if (lowerA < lowerB) {
      return -1;
    }
    if (lowerA > lowerB) {
      return 1;
    }
    return 0;
  });
  const columns = [
    {
      title: TitleValue("Expert"),
      dataIndex: "expertName",
      key: "expertName",
      width: "auto",
      align: "left",
      // sorter: (a, b) => a.expertName.length - b.expertName.length,

      render: (text, record) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              // color: "grey",
              cursor: "auto",
            }}
          >
            {record.key}
          </span>
        </>
      ),
    },

    ...reversedData?.map((domain) => ({
      title: TitleValue(domain),
      dataIndex: domain,
      key: domain,
      align: "center",
      // sorter: (a, b) =>
      //   a?.record[domain]?.answerCount - b.record[domain]?.answerCount,
      onHeaderCell: (column) => {
        return {
          onClick: () => {
            setDomain(column.key);
          },
          style: { cursor: "pointer", fontSize: "16px", fontWeight: "500" },
        };
      },
      width: "auto",
      render: (text, record) => (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
            onClick={() => crossNavigation(record, domain)}
          >
            {record[domain] !== null ? (
              <span
                style={{
                  fontSize: "13px",
                  color: "#2A364A",
                  fontWeight: "500",
                  // display: "flex",
                  // justifyContent: `flex-end`,
                  // width: `${record[domain].ratingCount !== 0 && "50%"} `,
                  // record[domain].ratingCount !== 0
                }}
              >
                {record[domain].answerCount}
              </span>
            ) : (
              <span
                style={
                  {
                    fontSize: "13px",
                    color: "#2A364A",
                    fontWeight: "500",
                  }
                }
              >
                0
              </span>
            )}
            {record[domain] !== null && record[domain].ratingCount !== 0 ? (
              // <div
              //   style={{
              //     display: "flex",
              //     alignItems: "center",
              //     width: "58%",
              //     paddingLeft: "5px",
              //   }}
              // >
              //   {" "}
              <>
                <span
                  style={{
                    paddingRight: "4px",
                    display: "flex",
                    alignItems: "center",
                    // justifyContent: "center",
                    // textAlign: "center",
                  }}
                >
                  <i
                    class="fa fa-star"
                    aria-hidden="true"
                    style={{
                      paddingRight: "3px",
                      color: "#ffc108",
                      fontSize: "13px",
                    }}
                  ></i>
                  <span style={{
                    fontSize: "13px",
                    color: "#2A364A",
                    fontWeight: "500"
                  }}>
                    {record[domain].rating !== 0 ? record[domain].rating : ""}{" "}

                  </span>
                </span>{" "}
                <span style={{ fontSize: "13px", fontWeight: "300" }}>
                  ({record[domain].ratingCount})
                </span>
              </>
            ) : // </div>
              null}
          </div>
        </>
      ),
    })),
  ];
  const sortByAnswerCount = (a, b) => {
    const answerCountA = Object.values(a).reduce((total, item) => {
      if (item && typeof item === "object" && "answerCount" in item) {
        return total + item.answerCount;
      }
      return total;
    }, 0);

    const answerCountB = Object.values(b).reduce((total, item) => {
      if (item && typeof item === "object" && "answerCount" in item) {
        return total + item.answerCount;
      }
      return total;
    }, 0);

    return answerCountB - answerCountA;
  };
  // Transform data for Ant Design table
  // console.log(" Object.keys(tableData)", Object.keys(tableData));
  const transformedData = Object.keys(tableData)?.map((expertName) => {
    const row = { key: expertName?.split("###")[0], expertName };
    domainNames?.forEach((domain) => {
      row[domain] = tableData[expertName][domain] || null;
    });

    return row;
  });
  const rowsValue = transformedData.sort(sortByAnswerCount);
  // console.log("transform table", transformedData);
  const goBackToTable = () => {
    setDomain(undefined);
  };

  return (
    <div 
    // style={containerStyle}
    >
<div
      style={{
        width: "100%",
        paddingRight: "15px",
        paddingTop: "15px",
        paddingBottom: "15px",
      }}
    >
      {domain === undefined ? (
        <Spin spinning={loading} style={{ width: "100%" }}>
          <div
            style={{
              textAlign: "center",
              paddingTop: "10px",
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <span style={textStylesHeader}>
            Expert Answers by Domains
            </span>
          </div>
          <Table
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            showSorterTooltip={false}
            columns={columns}
            dataSource={rowsValue}
            scroll={{
              x: 1000,
              // y: 542,
            }}
            // style={{ boxShadow: "7px 7px 20px lightgrey" }}
            onRow={(record, rowIndex) => {
              return {
                style: {
                  cursor: "pointer",
                  fontSize: "14px",
                  textAlign: "center",
                  fontWeight: 300,
                },
              };
            }}
          />
        </Spin>
      ) : (
        <>
          <span
            style={{ display: "flex", alignItems: "center", color: "1F93D2" }}
          >
           <span
            className={styles.backButtonNew}
            style={{ cursor: "pointer" }}
            onClick={() => goBackToTable()}
          >
            <i className="fa fa-arrow-left"></i>&nbsp;Back
          </span>
          </span>
          {/* <div style={containerStyles1}>
          <span
            className={styles.backButtonNew}
            style={{ cursor: "pointer" }}
            onClick={() => goBackToTable()}
          >
            <i className="fa fa-arrow-left"></i>&nbsp;Back
          </span>
        </div> */}

          {/* <VizButton size={1} type={"Primary"} onClick={goBackToTable}>
            Go Back
          </VizButton> */}
          <Grid container paddingTop={2}>
            <Grid item xs={12}>
              <Paper>
                <DomainSpecificGraphComponent domain={domain} />
              </Paper>
            </Grid>
          </Grid>
        </>
      )}
    </div>
    </div>
    
  );
}

export default ExpertAnswers;
